import {createStore} from 'redux';
import {StoreState} from './storeType';
import reducers from '../reducers';

export default createStore<StoreState>(reducers) as any;
